import PropTypes from "prop-types";
import {lifecycle} from "recompose";
import React from "react";
import currentUserHasAccess from "../../../../../util/widget-helper";
import {CUSTOMER_PRE_CHECKIN_IMAGE_WIDGET} from "../../../../process/ui-definition/process-ui";
import ContentBoxWithoutHeader from "../../../../layout/component/ContentBoxWithoutHeader";
import ContentBoxHeader from "../../../../layout/component/ContentBoxHeader";
import Row from "../../../../bootstrap/component/Row";
import Column from "../../../../bootstrap/component/Column";
import ToggleButton from "../../../../form/component/ToggleButton";
import ContentBoxBody from "../../../../layout/component/ContentBoxBody";
import DownloadImages from "./components/DownloadImages";
import PreCheckinPhotoList from "./components/PreCheckinPhotoList";

const CustomerPreCheckinImageWidget = ({
                                           canSeeImages,
                                           setImageTypeMetaData,
                                           imageVersionList,
                                           uploadCustomerImage,
                                           rotateCustomerImage,
                                           customerId,
                                           showImages,
                                           toggleImageView,
                                           findImageVersion,
                                       }) => {
    if (!currentUserHasAccess(CUSTOMER_PRE_CHECKIN_IMAGE_WIDGET) || !canSeeImages) {
        return null
    }

    return (
        <ContentBoxWithoutHeader>
            <ContentBoxHeader>
                <Row>
                    <Column size={8}>
                        <h1>Photo precheck</h1>
                    </Column>
                    <Column size={4} className="align-right">
                        <ToggleButton
                            toggle={toggleImageView}
                            active={showImages}
                            activeIcon="fa fa-search-minus"
                            inactiveIcon="fa fa-search-plus"
                        />
                    </Column>
                </Row>
            </ContentBoxHeader>
            <ContentBoxBody>
                {imageVersionList !== undefined || Object.keys(imageVersionList).length !== 0 ?
                    <DownloadImages
                        imageVersionList={imageVersionList}
                        customerId={customerId}
                    /> : ""}
                {showImages && <PreCheckinPhotoList
                    customerId={customerId}
                    setImageTypeMetaData={setImageTypeMetaData}
                    imageVersionList={imageVersionList}
                    uploadCustomerImage={uploadCustomerImage}
                    rotateCustomerImage={rotateCustomerImage}
                    findImageVersion={findImageVersion}/>}
            </ContentBoxBody>
        </ContentBoxWithoutHeader>
    )
}

CustomerPreCheckinImageWidget.propTypes = {
    customerId: PropTypes.string,
    uploadCustomerImage: PropTypes.func.isRequired,
    rotateCustomerImage: PropTypes.func.isRequired,
    showImages: PropTypes.bool.isRequired,
    toggleImageView: PropTypes.func.isRequired,
    canSeeImages: PropTypes.bool.isRequired,
    setImageTypeMetaData: PropTypes.func.isRequired,
    imageVersionList: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object
    ]),
    findImageVersion: PropTypes.func.isRequired,
}

export default lifecycle({})(CustomerPreCheckinImageWidget)



// WEBPACK FOOTER //
// ./src/modules/customer/component/task-widget/customerPreCheckinImageWidget/CustomerPreCheckinImageWidget.js